import { getAssetImage } from '../../app/util/util';
import { Database } from '../../server/database';
import { Server } from '../../server/server';
import { UIDialog } from '../common/ui/uiDialog';
import { UIImage } from '../common/ui/uiImage';
import { UIPanel } from '../common/ui/uiPanel';
import { UIPanelButton } from '../common/ui/uiPanelButton';
import { UIText } from '../common/ui/uiText';
import { numberWithCommas } from '../common/util';
import { Game } from './game';
import { GameScreen } from './gameScreen';
import { GameStyle } from './gameStyle';
import { TimePanel } from './timePanel';

export class GameOverDialog extends UIDialog {
  scoreText: UIText;
  bestScoreText: UIText;
  lifetimeScoreText: UIText;
  continueButton: UIPanelButton;
  quitButton: UIPanelButton;
  playAgainButton: UIPanelButton;

  loading: TimePanel;
  scoreLabel: UIText;
  bestScoreLabel: UIText;
  rewardsPanel: UIPanel;
  rewardsLoadingText: UIText;

  public build() {
    this.popup = new UIPanel({
      size: {x: 320, y: 380},
      anchor: {x: 0.5, y: 0.45},
      pivot: {x: 0.5, y: 0.5},
      position: {x: 0, y: 0},
      radius: GameStyle.dialog.panel.radius,
      color: GameStyle.dialog.panel.color,
      gradient: GameStyle.dialog.panel.gradient,
      borderColor: GameStyle.dialog.panel.borderColor,
      borderWidth: GameStyle.dialog.panel.borderWidth,
      shadow: GameStyle.dialog.panel.shadow,
      parent: this
    });

    let titleText = new UIText({
      text: 'GAME OVER!',
      position: {x: 0, y: 15},
      anchor: {x: 0.5, y: 0},
      pivot: {x: 0.5, y: 0},
      horizontalAlign: 'center',
      color: GameStyle.dialog.title.color,
      fontFamily: GameStyle.dialog.title.fontFamily,
      fontSize: GameStyle.dialog.title.fontSize,
      fontWeight: GameStyle.dialog.title.fontWeight,
      shadow: GameStyle.dialog.title.shadow,
      parent: this.popup
    });

    this.scoreLabel = new UIText({
      text: 'YOUR LEVEL & SCORE:',
      position: {x: 0, y: 60},
      anchor: {x: 0.5, y: 0},
      pivot: {x: 0.5, y: 0},
      horizontalAlign: 'center',
      color: GameStyle.results.label.color,
      fontFamily: GameStyle.results.label.fontFamily,
      fontSize: GameStyle.results.label.fontSize+2,
      fontWeight: '700',
      parent: this.popup
    });

    this.scoreText = new UIText({
      text: '1,234',
      position: {x: 0, y: 80},
      anchor: {x: 0.5, y: 0},
      pivot: {x: 0.5, y: 0},
      horizontalAlign: 'center',
      color: GameStyle.results.score.color,
      fontFamily: GameStyle.results.score.fontFamily,
      fontSize: GameStyle.results.score.fontSize,
      fontWeight: GameStyle.results.score.fontWeight,
      parent: this.popup
    });

    this.bestScoreLabel = new UIText({
      text: 'BEST SCORE',
      position: {x: 0, y: 125},
      anchor: {x: 0.5, y: 0},
      pivot: {x: 0.5, y: 0},
      horizontalAlign: 'center',
      color: GameStyle.results.label.color,
      fontFamily: GameStyle.results.label.fontFamily,
      fontSize: GameStyle.results.label.fontSize,
      fontWeight: GameStyle.results.label.fontWeight,
      parent: this.popup
    });

    this.bestScoreText = new UIText({
      text: '12,345',
      position: {x: 0, y: 145},
      anchor: {x: 0.5, y: 0},
      pivot: {x: 0.5, y: 0},
      horizontalAlign: 'center',
      color: GameStyle.results.score.color,
      fontFamily: GameStyle.results.score.fontFamily,
      fontSize: GameStyle.results.score.fontSize,
      fontWeight: GameStyle.results.score.fontWeight,
      parent: this.popup
    });

    let rewardsTitle = new UIText({
      text: 'REWARDS',
      position: {x: 0, y: 190},
      anchor: {x: 0.5, y: 0},
      pivot: {x: 0.5, y: 0},
      horizontalAlign: 'center',
      color: GameStyle.results.label.color,
      fontFamily: GameStyle.results.label.fontFamily,
      fontSize: GameStyle.results.label.fontSize,
      fontWeight: GameStyle.results.label.fontWeight,
      parent: this.popup
    });

    this.rewardsPanel = new UIPanel({
      size: {x: 270, y: 100},
      anchor: {x: 0.5, y: 0},
      pivot: {x: 0.5, y: 0},
      position: {x: 0, y: 210},
      color: '#00000040',
      radius: 10,
      parent: this.popup
    })

    this.rewardsLoadingText = new UIText({
      text: 'Loading...',
      position: {x: 0, y: 260},
      anchor: {x: 0.5, y: 0},
      pivot: {x: 0.5, y: 0.5},
      color: GameStyle.results.label.color,
      fontFamily: GameStyle.results.label.fontFamily,
      fontSize: GameStyle.results.label.fontSize,
      fontWeight: GameStyle.results.label.fontWeight,
      parent: this.popup
    });

    this.playAgainButton = new UIPanelButton({
      text : 'Play Again',
      anchor : {x : 0.5, y : 1},
      pivot : {x : 0, y : 1},
      position : {x : 15, y : -20},
      size : {x : 120, y : 40},
      callback : () => {
        this.onPlayAgain();
      },
      panelColors: GameStyle.dialog.button.panelColors,
      textColors: GameStyle.dialog.button.textColors,
      radius: GameStyle.dialog.button.radius,
      fontFamily: GameStyle.dialog.button.fontFamily,
      fontSize: GameStyle.dialog.button.fontSize,
      parent : this.popup
    });

    this.quitButton = new UIPanelButton({
      text : 'Quit Game',
      anchor : {x : 0.5, y : 1},
      pivot : {x : 1, y : 1},
      position : {x : -15, y : -20},
      size : {x : 120, y : 40},
      callback : () => {
        this.hide();
        Game.instance.quit();
      },
      panelColors: GameStyle.dialog.button.panelColors,
      textColors: GameStyle.dialog.button.textColors,
      radius: GameStyle.dialog.button.radius,
      fontFamily: GameStyle.dialog.button.fontFamily,
      fontSize: GameStyle.dialog.button.fontSize,
      parent : this.popup
    });
  }

  protected buildRewards(coins:number, asset:string) {
    if(coins == 0 && asset == '') {
      this.rewardsLoadingText.text = 'No rewards earned this game.';
      return;
    }

    this.rewardsLoadingText.visible = false;

    let rewardCount = 0;
    if(coins > 0) rewardCount++;
    if(asset != '') rewardCount++;

    if(coins > 0) {
      let coinPanel = new UIPanel({
        size: {x: 60, y: 60},
        anchor: {x: rewardCount == 1 ? 0.5 : 0.25, y: 0},
        pivot: {x: 0.5, y: 0},
        position: {x: 0, y: 12},
        radius: GameStyle.dialog.button.radius,
        color: '#00000040',
        borderColor: 'black',
        borderWidth: 2,
        parent: this.rewardsPanel
      });
  
      let coinImage = new UIImage ({
        url: '/assets/coin.png',
        size: {x: 50, y: 50},
        stretch: true,
        anchor: {x: 0.5, y: 0.5},
        pivot: {x: 0.5, y: 0.5},
        parent: coinPanel
      })
  
      let coinsEarnedText = new UIText({
        text: coins.toString() + ' Coins',
        position: {x: 0, y: 20},
        anchor: {x: 0.5, y: 1},
        pivot: {x: 0.5, y: 1},
        horizontalAlign: 'center',
        color: GameStyle.results.score.color,
        fontFamily: GameStyle.fonts.small.family,
        fontSize: GameStyle.fonts.small.size,
        fontWeight: '700',
        parent: coinPanel
      });
    }

    if(asset != '') {
      let assetInfo = Database.getAsset(asset);
      let assetName = assetInfo.name;

      if(assetInfo.type == 'pack')
        assetName = 'Pack';
      else if(assetInfo.type == 'consumable')
        assetName = 'Powerup';
      else if(assetInfo.category == 'landmark')
        assetName = 'Landmark';
      else if(assetInfo.category == 'banner')
        assetName = 'Banner';
      else if(assetInfo.category == 'portrait')
        assetName = 'Portrait';
      else
        assetName = '';
      
      let assetPanel = new UIPanel({
        size: {x: 60, y: 60},
        anchor: {x: rewardCount == 1 ? 0.5 : 0.75, y: 0},
        pivot: {x: 0.5, y: 0},
        position: {x: 0, y: 12},
        radius: GameStyle.dialog.button.radius,
        color: '#00000040',
        borderColor: 'black',
        borderWidth: 2,
        parent: this.rewardsPanel
      });

      let assetImage = new UIImage ({
        url: getAssetImage(assetInfo),
        size: {x: 50, y: 50},
        stretch: true,
        anchor: {x: 0.5, y: 0.5},
        pivot: {x: 0.5, y: 0.5},
        parent: assetPanel
      });

      if(assetInfo.category == 'banner') {
        assetImage.size = {x: 58, y: 0};
        assetImage.fitAspect = {x: 0, y: 160/600};
      }
  
      let assetNameText = new UIText({
        text: assetName,
        position: {x: 0, y: 20},
        anchor: {x: 0.5, y: 1},
        pivot: {x: 0.5, y: 1},
        horizontalAlign: 'center',
        color: GameStyle.results.score.color,
        fontFamily: GameStyle.fonts.small.family,
        fontSize: GameStyle.fonts.small.size,
        fontWeight: '700',
        parent: assetPanel
      });
    }
  }

  public onWake() {
    this.rewardsPanel.removeAllChildren();
    this.scoreLabel.text = 'LEVEL ' + Game.instance.level;
    this.scoreText.text = numberWithCommas(Game.instance.score);
    this.bestScoreLabel.text = 'BEST SCORE';
    this.bestScoreText.text = '-';
    this.rewardsLoadingText.visible = true;
    this.rewardsLoadingText.text = 'Loading...';
    this.recordScore();
  }

  protected async recordScore() {
    this.playAgainButton.disabled = true;

    Game.instance.recordScore(Game.instance.score, (success:boolean, highScore:number, coins:number, asset:string)=>{
      this.playAgainButton.disabled = false;
      if(success) {
        this.buildRewards(coins, asset);
        this.bestScoreLabel.text = (Game.instance.score == highScore) ? 'HIGH SCORE!' : 'BEST SCORE';
        this.bestScoreText.text = numberWithCommas(highScore);
      }
      else {
        this.bestScoreText.text = 'ERR';
        this.rewardsLoadingText.text = 'Failed to submit score!';
      }
    });
  }

  protected onPlayAgain() {
    if(Game.instance.isTournament()) {
      let costToPlay = Database.getTournamentCost('whacka');
      if(Server.user.getCoinCount() < costToPlay) {
        Game.instance.showAlert('You do not have enough coins\nto play another tournament game.');  
        return;     
      }
    }

    this.hide();
    Game.instance.gameScreen.startGame();
  }
}